export const getBoardIdFromUrlOrEnvironment = (id?: string | undefined) => {
  if (process.env.VITE_LOCAL_BOARD_ID) {
    return process.env.VITE_LOCAL_BOARD_ID;
  }

  const location = globalThis.location;
  if (!location) {
    return id;
  }

  const url = new URL(location.href);

  const hash = url.hash;
  if (hash.includes('/whiteboard/')) {
    const hashId = hash.split('/whiteboard/').pop();
    if (hashId) {
      return hashId;
    }
  }

  const path = url.pathname;
  if (path.includes('/whiteboard/')) {
    const pathId = path.split('/whiteboard/').pop();
    if (pathId) {
      return pathId;
    }
  }

  return id;
};
